import React from 'react';
import styled from '@emotion/styled';

const PhraseContainer = styled.div`
    padding: 2rem;
    border-radius: 5rem;
    background-color: #060606;
    color: #fff;
    border: 5px solid white;
    max-width: 80%;

    @media (max-width: 700px){
        margin-top: 18.7em;
        font-size: 0.8rem;
    }

    h1{
        font-size: 1.8em;
        font-weight: lighter;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;    
        text-align: center;    
    }

    p{
        margin-top: 1rem;
        text-align: right;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;    

    }
`;

const Phrase = ({phrase}) => {
    return (
        <PhraseContainer>
            <h1>{phrase.quote}</h1>
            <p>{phrase.character}</p>
        </PhraseContainer>
     );
}
 
export default Phrase;